<template>
    <div>
        <h1>솔닥 의료 마이데이터 개인정보 수집·이용 동의</h1>
        주식회사 솔닥(이하 “회사”라 합니다)은 회원의 개인정보보호법 제35조의2 제1항 제1호에 따른 개인정보 전송요구권 행사를 통한 의료 마이데이터 연동, 본인 확인, 계정 연계 및 서비스 제공을 위하여 아래와 같이 회원의 개인정보를 수집·이용합니다.<br>
        회원은 아래 내용을 자세히 확인한 후 동의 여부를 결정할 수 있습니다.<br>
        본 동의는 솔닥 의료 마이데이터 서비스 제공을 위해 필요한 필수 동의입니다. 동의하지 않을 경우 의료 마이데이터 연동, 건강정보 조회, 연동기관 관리 등 관련 서비스를 이용할 수 없습니다.<br>
        구체적인 의료 마이데이터 전송요구에 관한 사항은 회원이 마이데이터 연동 과정에서 별도 전송요구 화면을 통해 직접 선택·확인하는 내용에 따릅니다.<br>
        <h3>1. 개인정보 수집·이용 목적</h3>
        개인정보 전송요구권 행사를 통한 솔닥 의료 마이데이터 서비스 내 건강정보 통합조회, 회원 식별, 계정 연계, 마이데이터 연동 관리 및 맞춤형 건강관리 서비스 제공<br>
        <h3>2. 수집·이용 및 전송을 요구하는 개인정보 항목</h3>
        회사는 의료 마이데이터 연동 및 회원 식별을 위해 아래 개인정보를 수집·이용하거나 보건의료정보전송자로부터 전송받을 수 있습니다.<br>
        필수정보: 이름, 생년월일, 휴대폰번호, 성별, CI, MHID(건강정보고속도로 아이디)<br>
        ※ 회사가 실제로 수집·이용하거나 전송받는 개인정보 항목은 회원이 선택한 연동기관, 전송요구 항목, 보건의료정보전송자의 제공 범위 및 관계 법령에 따라 달라질 수 있습니다.<br>
        <h3>3. 개인정보의 보유 및 이용기간</h3>
        마이데이터 서비스 이용기간 동안 보유하며, 마이데이터 서비스 이용 철회 또는 솔닥 회원 탈퇴 시 즉시 파기합니다. 단, 개인정보보호법 시행령 제42조의6 제9항에 의해 보관해야 하는 전송내역은 3년간 보관됩니다.<br><br>
        회원은 본 개인정보 수집·이용 및 전송요구에 대한 동의를 거부할 수 있습니다.<br>
        다만, 본 동의는 솔닥 의료 마이데이터 서비스 제공을 위해 필요한 필수 동의이므로, 동의하지 않을 경우 의료 마이데이터 연동, 건강정보 조회, 연동기관 관리 등 관련 서비스 이용이 제한될 수 있습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataPrivacyCollection'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/PrivacyCollection.vue